import config from 'config';
import { app } from 'core';
import { Container } from 'ui/components/primitives';
import { Accordion } from './components/Accordion';
import { Divider } from './components/Divider';
import { TalkTo } from '../TalkTo/TalkTo';
import { UtilLinks } from './components/UtilLinks';
import { FooterComponents } from './Footer.styles';
import { FOOTER_CONST } from './components/components.d';
import { Social } from './components/Social';
import { Info } from './components/Info';

const FooterBase = () => {
  const isMobile = app.hooks.useApp('isMobile');

  return (
    <FooterComponents.Principal data-testid={FOOTER_CONST.TEST_ID}>
      <Container>
        {isMobile ? (
          <>
            <Divider />
            <Accordion title={`Fale com ${config.app.name}`}>
              <TalkTo />
            </Accordion>
            <Divider />
            <Accordion title="Link úteis">
              <UtilLinks data={config.footer.links} />
            </Accordion>
            <Divider />
            <Social data={config.footer.socialMediaAndApps} />
          </>
        ) : (
          <FooterComponents.Base>
            <FooterComponents.Section>
              <FooterComponents.Title>Fale com {config.app.name}</FooterComponents.Title>
              <TalkTo />
            </FooterComponents.Section>

            <FooterComponents.Section>
              <FooterComponents.Title>Links úteis</FooterComponents.Title>
              <UtilLinks data={config.footer.links} />
            </FooterComponents.Section>

            <Social data={config.footer.socialMediaAndApps} />
          </FooterComponents.Base>
        )}
        <Info />
      </Container>
    </FooterComponents.Principal>
  );
};

export default FooterBase;
